import { createContext, useReducer, useEffect, useState } from "react";

export const UserAuthContext = createContext();

export const userAuthReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      localStorage.setItem("user", JSON.stringify(action.payload));
      return { user: action.payload };
    case "LOGOUT":
      localStorage.removeItem("user");
      return { user: null };
    case "UPDATE_USER":
      localStorage.setItem("user", JSON.stringify(action.payload));
      return { user: action.payload };
    default:
      return state;
  }
};

export const UserAuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(userAuthReducer, { user: null });
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("user");
    if (saved) {
      dispatch({ type: "LOGIN", payload: JSON.parse(saved) });
    }
    setAuthReady(true);
  }, []);

  return (
    <UserAuthContext.Provider value={{ ...state, dispatch, authReady }}>
      {children}
    </UserAuthContext.Provider>
  );
};
